class BannerCarousel {
  constructor(sectionId, config) {
    this.sectionId = sectionId;
    this.config = config;
    this.swiper = null;
    this.init();
  }

  init() {
    const swiperEl = document.querySelector('.banner-swiper-' + this.sectionId);
    
    if (!swiperEl) {
      console.warn('Swiper element not found for section:', this.sectionId);
      return;
    }

    // Si ya existe una instancia, destrúyela
    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    // Espera a que Swiper esté disponible
    this.waitForSwiper(() => {
      this.initSwiper(swiperEl);
    });
  }

  waitForSwiper(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
    } else {
      const checkSwiper = setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          clearInterval(checkSwiper);
          callback();
        }
      }, 50);

      // Timeout después de 5 segundos
      setTimeout(() => {
        clearInterval(checkSwiper);
        console.error('Swiper library failed to load');
      }, 5000);
    }
  }

  initSwiper(swiperEl) {
    try {
      this.swiper = new Swiper(swiperEl, this.config);
      console.log('Banner Carousel initialized for section:', this.sectionId);
    } catch (error) {
      console.error('Error initializing Swiper:', error);
    }
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

// Función global para inicializar el carousel
window.initBannerCarousel = function(sectionId, config) {
  return new BannerCarousel(sectionId, config);
};

// Para el editor de temas de Shopify
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    // El evento se maneja en el liquid inline
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const swiperEl = event.target.querySelector('[class*="banner-swiper-"]');
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }
  });
}

